import { Typography } from 'antd';

import { ShiftListItemDto, ShiftStatus } from '@clh/api-client';

import ObjectPropertyList from '../../../record-details/object-property-list';

export const CancellationDetails = ({
    selection,
}: {
    selection: ShiftListItemDto;
}) => {
    if (selection.status !== ShiftStatus.Canceled) {
        return null;
    }

    return (
        <>
            <Typography.Title level={4}>Cancellation Details</Typography.Title>

            <ObjectPropertyList
                values={{
                    date: selection.cancellationDate,
                    canceledBy: selection.canceledByProfile,
                    reason: selection.cancellationReason,
                    comment: selection.cancellationComment,
                }}
                fields="*"
            />
        </>
    );
};
